import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.605 7.395a.86.86 0 0 1 0 1.213l-5.141 5.141a.858.858 0 0 1-1.213-1.213L9.787 8 5.254 3.464a.858.858 0 0 1 1.213-1.213l5.14 5.141z"
    }, null, -1)
  ]))]))
}
export default { render: render }